<!--    
@description 弹出框
@author zhijie.huang
@date 2018/9/27
@version v1.1.0

/**** props ****/
// id
id: String,
// 弹窗标题
title: String,
// 是否可见
visible: true/false,
// 尺寸; 1 = 小, 2 = 中, 3 = 大；默认 1
size: Number
// lebal尺寸; 1 = 小, 2 = 中, 3 = 大；默认 1
labelSize: Number
-->
<script>
const DIALOG_WIDTH = ['400px', '600px', '800px']
const LABEL_WIDTH = ['80px', '100px', '120px', '150px', '200px']

export default {
  data () {
    return {
      key: 'dialog' // TODO 是否需要可变
    }
  },
  watch: {

  },
  computed: {
    iVisible: {
      get () {
        return this.visible
      },
      set (val) {
        this.$emit('update:visible', val)
      }
    },
    iWidth () {
      const width = DIALOG_WIDTH
      const i = this.size - 1
      if (width[i]) {
        return width[i]
      }
      return width[0]
    },
    iLabelWidth () {
      const width = LABEL_WIDTH
      const i = this.labelSize - 1
      if (width[i]) {
        return width[i]
      }
      return width[0]
    }
  },
  props: {
    id: {
      type: String,
      require: true
    },
    title: {
      type: String,
      default () {
        return this.$t('common.tips')
      }
    },
    visible: {
      type: Boolean,
      default: false
    },
    size: {
      type: Number,
      default: 1
    },
    labelSize: {
      type: Number,
      default: 1
    }
  }
}
</script>
